import * as Yup from 'yup';

export function getPostInitialValues(commissionList, editFlag) {
  return {
    comment:""
  };
}

const VALIDATION_SCHEMA = () => {
      let schemaAttributes = {
        comment:Yup.string().trim().required('Comment is required.')
      };
      return Yup.object().shape(schemaAttributes);
}
export { VALIDATION_SCHEMA };
